import { render, staticRenderFns } from "./OPH.vue?vue&type=template&id=19156ba6&"
import script from "./OPH.vue?vue&type=script&lang=js&"
export * from "./OPH.vue?vue&type=script&lang=js&"
import style0 from "./OPH.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports